import './HelpTopic.scss';
import React from 'react';
import PropTypes from 'prop-types';

import provideTranslations from 'decorators/provideTranslations';

@provideTranslations('help')
class HelpTopicContainer extends React.Component {
  render() {
    return (
      <HelpTopic {...this.props} />
    );
  }
}

class HelpTopic extends React.Component {
  static propTypes = {
    contentHeight: PropTypes.number,
    helpNode: PropTypes.object.isRequired,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  handleResetScroll() {
    window.scrollTo(0, 0);
  }

  renderFooter() {
    const { getString } = this.context;
    if (this.props.contentHeight < window.innerHeight) {
      return null;
    }

    return (
      <div className="aa-help-topic__footer">
        <a href="#" onClick={this.handleResetScroll}>
          { getString('AA_Help_Back_To_Top') }
        </a>
      </div>
    );
  }

  render() {
    return (
      <div className="aa-help-topic-container">
        <div className="aa-help-topic">
          <h3 id="aa-help-topic-title" className="aa-help-topic__title">{this.props.helpNode.title}</h3>
          <div className="aa-help-topic__content" dangerouslySetInnerHTML={{ __html: this.props.helpNode.content }} />
          { this.renderFooter() }
        </div>
      </div>
    );
  }
}

export default HelpTopicContainer;
